import React from 'react';
import { useParams } from 'react-router-dom';
import RI001 from 'pages/reference-implementation/provisioning/RI001';
import RI002 from 'pages/reference-implementation/provisioning/RI002';
import RI003 from 'pages/reference-implementation/provisioning/RI003';
import RI004O from 'pages/reference-implementation/provisioning/RI004O';
import RI003O from 'pages/reference-implementation/provisioning/RI003O';
import RI003AWS from 'pages/reference-implementation/provisioning/RI003AWS';
import RI002O from 'pages/reference-implementation/provisioning/RI002O';
import {
    RICatalogCode001,
    RICatalogCode002,
    RICatalogCode003,
    RICatalogCode004,
    // RICatalogCode005,
    RICatalogCode004A,
    RICatalogCode003A,
    RICatalogCode001A,
    RICatalogCode003O,
    RICatalogCode003AWS,
    RICatalogCode002O,
    RICatalogCode004O,
} from 'pages/reference-implementation/utils/RICatalogCode';
import { allowedServices, isDiscontinuedService, isCMPAdmin } from 'utils';
import { PageNotFound } from 'pages';

const RiProvisioning = () => {
    const { catalogCode } = useParams();

    // Check if service is discontinued and user is not CMP Admin
    const isServiceDiscontinued = isDiscontinuedService(catalogCode) && !isCMPAdmin();

    return (
        <>
            {catalogCode && [RICatalogCode001, RICatalogCode001A]?.includes(catalogCode) && allowedServices(catalogCode) && !isServiceDiscontinued && <RI001 />}
            {catalogCode && catalogCode === RICatalogCode002 && allowedServices(catalogCode) && !isServiceDiscontinued && <RI002 />}
            {catalogCode && catalogCode === RICatalogCode003O && allowedServices(catalogCode) && !isServiceDiscontinued && <RI003O />}
            {catalogCode && catalogCode === RICatalogCode004O && allowedServices(catalogCode) && !isServiceDiscontinued && <RI004O />}
            {catalogCode && catalogCode === RICatalogCode002O && allowedServices(catalogCode) && !isServiceDiscontinued && <RI002O />}
            {catalogCode &&
                [
                    RICatalogCode003,
                    RICatalogCode003A,
                    RICatalogCode004,
                    RICatalogCode004A,
                    // RICatalogCode005
                ]?.includes(catalogCode) &&
                allowedServices(catalogCode) &&
                !isServiceDiscontinued && <RI003 />}
            {/* aws */}
            {catalogCode && catalogCode === RICatalogCode003AWS && allowedServices(catalogCode) && !isServiceDiscontinued && <RI003AWS />}
            {(!allowedServices(catalogCode) || isServiceDiscontinued) && <PageNotFound />}
        </>
    );
};

export default React.memo(RiProvisioning);
